import { render } from "./TheLanguageSwitcher.vue?vue&type=template&id=0b618cbe&scoped=true&ts=true"
import script from "./TheLanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./TheLanguageSwitcher.vue?vue&type=script&lang=ts"

import "./TheLanguageSwitcher.vue?vue&type=style&index=0&id=0b618cbe&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b618cbe"]])

export default __exports__